/*
 * Copyright (c) 2021 WIT Software. All rights reserved.
 *
 * WIT Software Confidential and Proprietary information. It is strictly forbidden for 3rd parties to modify, decompile,
 * disassemble, defeat, disable or circumvent any protection mechanism; to sell, license, lease, rent, redistribute or
 * make accessible to any third party, whether for profit or without charge.
 *
 */

import layoutProgressBar from './layoutProgressBar';
import startUp from './startUp';
import onDemand from './onDemand';
import watchTv from './watchTv';
import myTv from './myTv';
import search from './search';
import router from './router';
import settings from './settings';
import player from './player';
import programInfo from './programInfo';
import folderInfo from './folderInfo';
import visualScrubber from './visualScrubber';
import offline from './offline';
import analyticsWatchers from './analytics';

export default {
  layoutProgressBar,
  startUp,
  onDemand,
  watchTv,
  myTv,
  search,
  router,
  settings,
  player,
  programInfo,
  folderInfo,
  visualScrubber,
  offline,
  analyticsWatchers,
};
